import classNames from 'classnames'
import StoreListItem from '../StoreListItem/StoreListItem'
import { StoresListProps } from './StoresList.types'

const StoresList = ({ stores, onClickStore }: StoresListProps) => {
  return (
    <div>
      {stores.map((store, index) => {
        return (
          <button
            type='button'
            key={index}
            className={classNames(
              'px-4 border-b border-b-primary-border text-left',
              index === 0 ? 'pb-6' : 'py-6'
            )}
            onClick={() => {
              if (onClickStore) {
                onClickStore(store)
              }
            }}>
            <StoreListItem index={index + 1} store={store} />
          </button>
        )
      })}
    </div>
  )
}

export default StoresList
